import { setMwValue, getMwValue, setMwToken, getMwToken } from './utils';
import {API_URL} from './application';

const USERCOMPANIES_GET_URL = API_URL+'api/Companies/GetCompaniesByUser?id='

const COMPANY_SAVE_POST_URL = API_URL+'api/Companies/UpdateCompany'
const COMPANY_CREATE_POST_URL = API_URL+'api/Companies'

const COMPANY_SAVE_ADMIN_POST_URL = API_URL+'api/Companies/UpdateCompanyAdmin'
const ALLCOMPANIES_GET_URL = API_URL+'api/Companies/GetAllCompanies'

const COMPANYUSERS_GET_URL = API_URL+'api/Companies/GetUsersByCompany?CompanyId='
const COMPANYAPPLICATIONS_GET_URL = API_URL+'api/Companies/GetLoanApplicationsByCompany?CompanyId='
const COMPANYLOANS_GET_URL = API_URL+'api/Companies/GetLoansByCompany?CompanyId='


export const REQUEST_COMPANIES = 'REQUEST_COMPANIES'
export const RECEIVE_COMPANIES_SUCCESS = 'RECEIVE_COMPANIES_SUCCESS'
export const RECEIVE_COMPANIES_ERROR = 'RECEIVE_COMPANIES_ERROR'

export const REQUEST_COMPANY_SAVE = 'REQUEST_COMPANY_SAVE'
export const RECEIVE_COMPANY_SAVE_SUCCESS = 'RECEIVE_COMPANY_SAVE_SUCCESS'
export const RECEIVE_COMPANY_SAVE_ERROR = 'RECEIVE_COMPANY_SAVE_ERROR'

export const REQUEST_COMPANY_CREATE = 'REQUEST_COMPANY_CREATE'
export const RECEIVE_COMPANY_CREATE_SUCCESS = 'RECEIVE_COMPANY_CREATE_SUCCESS'
export const RECEIVE_COMPANY_CREATE_ERROR = 'RECEIVE_COMPANY_CREATE_ERROR'

export const REQUEST_COMPANY_LOANS= 'REQUEST_COMPANY_LOANS'
export const RECEIVE_COMPANY_LOANS_SUCCESS = 'RECEIVE_COMPANY_LOANS_SUCCESS'
export const RECEIVE_COMPANY_LOANS_ERROR = 'RECEIVE_COMPANY_LOANS_ERROR'


export const REQUEST_COMPANY_APPLICATIONS = 'REQUEST_COMPANY_APPLICATIONS'
export const RECEIVE_COMPANY_APPLICATIONS_SUCCESS = 'RECEIVE_COMPANY_APPLICATIONS'
export const RECEIVE_COMPANY_APPLICATIONS_ERROR = 'RECEIVE_COMPANY_APPLICATIONS_ERROR'

export const REQUEST_COMPANY_USERS = 'REQUEST_USERS_USERS'
export const RECEIVE_COMPANY_USERS_SUCCESS = 'RECEIVE_COMPANY_USERS'
export const RECEIVE_COMPANY_USERS_ERROR = 'RECEIVE_COMPANY_USERS_ERROR'



export function updateCompany(company) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_COMPANY_SAVE, company: company});        
         return fetch(COMPANY_SAVE_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...company
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_COMPANY_SAVE_SUCCESS, company: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function createCompanyAdmin(company) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_COMPANY_CREATE, company: company});        
         return fetch(COMPANY_CREATE_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...company
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_COMPANY_CREATE_SUCCESS, company: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}


export function updateCompanyAdmin(company) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_COMPANY_SAVE, company: company});        
         return fetch(COMPANY_SAVE_ADMIN_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...company
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_COMPANY_SAVE_SUCCESS, company: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}


export function getFetchCompaniesByUserId(userid) {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_COMPANIES});        
         return fetch(USERCOMPANIES_GET_URL+userid, 
            { headers: {           
                'authorization' : 'bearer '+token
            }                       
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_COMPANIES_SUCCESS, companies: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function getFetchApplicationsByCompanyId(companyid) {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_COMPANY_APPLICATIONS});        
         return fetch(COMPANYAPPLICATIONS_GET_URL+companyid, 
            { headers: {           
                'authorization' : 'bearer '+token
            }                       
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_COMPANY_APPLICATIONS_SUCCESS, items: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function getFetchLoansByCompanyId(companyid) {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_COMPANY_LOANS});        
         return fetch(COMPANYLOANS_GET_URL+companyid, 
            { headers: {           
                'authorization' : 'bearer '+token
            }                       
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_COMPANY_LOANS_SUCCESS, items: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}



export function getFetchUsersByCompanyId(companyid) {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_COMPANY_USERS});        
         return fetch(COMPANYUSERS_GET_URL+companyid, 
            { headers: {           
                'authorization' : 'bearer '+token
            }                       
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_COMPANY_USERS_SUCCESS, items: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}



export function getFetchCompanies() {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_COMPANIES});        
         return fetch(ALLCOMPANIES_GET_URL, 
            { headers: {           
                'authorization' : 'bearer '+token
            }                       
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_COMPANIES_SUCCESS, companies: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}
